import { kawatechOfficialLogos } from '../seo/metadata';

export const kawatechLogos = kawatechOfficialLogos;

export const KawaTechLogo = ({ variant = 'positive', className = '' }) => (
  <span className={`inline-flex items-center ${className}`}>
    <img
      src={variant === 'negative' ? kawatechLogos.negative : kawatechLogos.positive}
      alt="KawaTech"
      className="h-full w-auto"
      onError={(event) => {
        event.currentTarget.style.display = 'none';
        event.currentTarget.nextElementSibling?.removeAttribute('hidden');
      }}
    />
    <span
      hidden
      className={`text-lg font-bold ${variant === 'negative' ? 'text-white' : 'text-primary'}`}
    >
      KawaTech
    </span>
  </span>
);
